import {
  CancellationReason,
} from "apps/website/components/form-service/fields/helpers/cancellation-reason";

export function getCancellationReason(primaryReason: string, secondaryReason: string): CancellationReason {
  if (primaryReason === "TOO_EXPENSIVE") {
    if (secondaryReason === "OVER_MY_BUDGET") {
      return CancellationReason.TOO_EXPENSIVE_OVER_MY_BUDGET;
    }
    if (secondaryReason === "OTHER_BRANDS_CHEAPER") {
      return CancellationReason.TOO_EXPENSIVE_OTHER_BRANDS_ARE_CHEAPER;
    }
    if (secondaryReason === "EXPENSIVE_WORTH") {
      return CancellationReason.TOO_EXPENSIVE_NOT_WORTH_THE_COST;
    }

    return CancellationReason.OTHER;
  }

  if (primaryReason === "LIMITED_FREEZER_SPACE") {
    if (secondaryReason === "ACCUMULATION_OVER_TIME") {
      return CancellationReason.FREEZER_SPACE_ACCUMULATION;
    }
    if (secondaryReason === "NO_MORE_ROOM") {
      return CancellationReason.FREEZER_SPACE_NOT_ENOUGH_SPACE;
    }

    return CancellationReason.OTHER;
  }

  if (primaryReason === "SUB_DOESNT_WORK") {
    if (secondaryReason === "NEED_LESS_FOOD_THAN_SUBSCRIPTION") {
      return CancellationReason.SUBSCRIPTION_DOESNT_WORK_NEED_LESS_FOOD;
    }
    return CancellationReason.OTHER;
  }

  if (primaryReason === "COMING_BACK") {
    if (secondaryReason === "COMINGBACK_MULTIFEEDING") {
      return CancellationReason.COMING_BACK_FEEDING_OTHER_FOODS_ALONGSIDE_KATKIN;
    }
    return CancellationReason.OTHER;
  }

  return CancellationReason.OTHER;
}
